import { Message } from 'element-ui'

export const validateForm = () => {
  Message.error('Oops, hay datos requeridos que debes ingresar!')
}
